// InstruVia — Dental & Medical Equipment Sourcing Partner

// Navigation links (anchor-based single page)
export const NAV_LINKS = [
  { id: 1, title: 'About', href: '#about' },
  { id: 2, title: 'Services', href: '#services' },
  { id: 3, title: 'Why InstruVia', href: '#why-us' },
  { id: 4, title: 'Dentifique', href: '#dentifique' },
  { id: 5, title: 'Partners', href: '#partners' },
  { id: 6, title: 'Contact', href: '#contact' },
];

// Hero Section
export const HERO_CONTENT = {
  headline: 'Supplying Dentistry. Powering Growth. Delivering Confidence.',
  subtext: 'InstruVia connects dental practices with trusted equipment, instruments, and operational solutions — from sourcing to setup.',
  buttons: [
    { label: 'Explore Solutions', href: '#services', variant: 'primary' },
    { label: 'Partner With Us', href: '#vendor-partnership', variant: 'secondary' },
    { label: 'Contact Us', href: '#contact', variant: 'outline' },
  ],
};

// About Section
export const ABOUT_CONTENT = {
  heading: 'Who We Are',
  text: 'InstruVia is a modern dental and medical equipment sourcing partner focused on reliability, transparency, and long-term value. We work directly with manufacturers and authorized distributors to help clinics access high-quality equipment with confidence.',
  text2: 'Our approach is consultative — we don\'t just supply products, we help practices choose the right solutions based on workflow, growth goals, and operational needs.',
};

// What We Do Section
export const SERVICES = [
  {
    id: 1,
    icon: 'Search',
    title: 'Equipment Sourcing',
    description: 'We connect clinics with trusted global and local manufacturers.',
  },
  {
    id: 2,
    icon: 'Wrench',
    title: 'Instruments & Supplies',
    description: 'High-quality dental instruments tailored to practice needs.',
  },
  {
    id: 3,
    icon: 'HeartHandshake',
    title: 'Vendor Coordination',
    description: 'We handle communication, pricing, and logistics.',
  },
  {
    id: 4,
    icon: 'TrendingUp',
    title: 'Setup & Growth Support',
    description: 'Through Dentifique, we help optimize clinic performance.',
  },
];

// Why Choose InstruVia
export const WHY_CHOOSE = [
  'Curated vendor network',
  'Consultative equipment selection',
  'Growth-focused partnerships',
  'Transparent pricing model',
  'Scalable procurement support',
  'Canada-focused dental expertise',
];

// Dentifique Section
export const DENTIFIQUE_CONTENT = {
  heading: 'Dentifique - Subsidiary of InstruVia',
  subtitle: 'Practice Growth Partner',
  text: 'Dentifique is InstruVia\'s strategic practice growth division. While InstruVia focuses on equipment sourcing, Dentifique helps clinics optimize operations, improve workflows, and scale sustainably.',
  features: [
    'Equipment sourcing',
    'Practice consulting',
    'Operational optimization',
    'Growth strategy',
    'Expansion planning',
  ],
  buttonText: 'Learn About Dentifique',
};

// TSR Steel Mills Section
export const TSR_CONTENT = {
  heading: 'Powered by Industrial Strength - TSR Steel Mills Pvt. Ltd.',
  text: 'InstruVia is powered by TSR Steel Mills, bringing manufacturing expertise, operational discipline, and supply chain reliability to our platform. This partnership strengthens our ability to source, coordinate, and deliver equipment with confidence.',
  tagline: 'Powered by TSR Steel Mills',
};

// Who We Work With
export const CLIENTS = [
  'Independent dental clinics',
  'Multi-location practices',
  'New clinic setups',
  'Expanding practices',
  'Healthcare groups',
  'Procurement managers',
];

// Vendor Partnership
export const VENDOR_CONTENT = {
  heading: 'Partner With InstruVia',
  text: 'We collaborate with manufacturers and distributors looking to expand their presence through a trusted sourcing partner.',
  benefits: [
    'Market access',
    'Client introductions',
    'Product positioning',
    'Long-term partnerships',
  ],
  buttonText: 'Become a Vendor Partner',
};

// Shop Coming Soon
export const SHOP_CONTENT = {
  heading: 'Shop & Inventory Platform — Coming Soon',
  text: 'Our centralized procurement platform is currently in development. Soon, clinics will be able to browse equipment, request quotes, and manage sourcing through a unified InstruVia interface.',
  features: [
    'Live equipment catalog',
    'Vendor-backed listings',
    'Request-for-quote system',
    'Inventory visibility',
    'Procurement dashboard',
  ],
  buttonText: 'Join Early Access',
};

// Contact Section
export const CONTACT_CONTENT = {
  heading: 'Contact Us',
  inquiryTypes: [
    'Equipment Inquiry',
    'Vendor Partnership',
    'General Inquiry',
    'Dentifique Services',
  ],
};

// Support Section
export const SUPPORT_CONTENT = {
  heading: 'Support & Feedback',
  text: 'We value transparency and continuous improvement. If you have any concerns regarding equipment, partnerships, or service, our team is ready to assist.',
  issueTypes: [
    'Equipment Issue',
    'Partnership Concern',
    'Service Feedback',
    'Other',
  ],
};

// Footer
export const FOOTER_LINKS = [
  { label: 'About InstruVia', href: '#about' },
  { label: 'Dentifique', href: '#dentifique' },
  { label: 'Vendor Partnerships', href: '#vendor-partnership' },
  { label: 'Contact', href: '#contact' },
  { label: 'Support', href: '#support' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms', href: '#' },
];

export const COMPANY_INFO = {
  name: 'InstruVia',
  tagline: 'Dental & Medical Equipment Sourcing Partner',
  copyright: 'InstruVia — Dental & Medical Equipment Sourcing Partner',
};